<div [formGroup]="formGroup" *ngIf="controlName && currentDate" class="date-picker-wrapper">
  <!-- Label Section -->
  <div class="date-picker-label mb-1" *ngIf="label">
    <span class="required-asterisk" *ngIf="required">*</span>
    <span class="label-text">{{ label }}</span>
  </div>
  
  <mat-form-field appearance="outline" [class.w-full]="width === 'full'" class="date-input-field">
    <input
      class="hide-hint"
      matInput
      mask="00/00/0000"
      [disabled]="disabled"
      [(ngModel)]="dateValFormatted"
      [ngModelOptions]="{ standalone: true }"
      (blur)="maskChange()"
      [placeholder]="placeholder"
      [required]="required"
    />

    <!-- actual date input -->
    <input
      class="hidden"
      (blur)="dateSelected()"
      [ngModelOptions]="{ standalone: true }"
      [(ngModel)]="dateVal"
      type="text"
      (dateChange)="dateSelected()"
      [matDatepicker]="picker"
      [min]="minDate"
      [max]="maxDate"
      [required]="required"
      [disabled]="disabled"
    />

    <mat-datepicker-toggle
      [disabled]="disabled"
      matIconSuffix
      [for]="picker"
      (click)="onDatePickerToggle()"
    >
      <img
        [ngStyle]="{ opacity: disabled ? 0.5 : 1 }"
        style="width: 17px; margin-bottom: 2px; margin-left: 10px; margin-top: 5px;"
        matDatepickerToggleIcon
        src="/assets/calender-icon.svg"
        alt=""
      />
    </mat-datepicker-toggle>

    <mat-datepicker
      #picker
      (closed)="maskChange()"
      [dateClass]="highlightCustomToday"
    ></mat-datepicker>
  </mat-form-field>

    <mat-error *ngIf="formGroup?.get(controlName)?.touched && formGroup?.get(controlName)?.errors">
      <ng-container [ngSwitch]="(formGroup.get(controlName)?.errors | keyvalue)?.[0]?.key">
        <span *ngSwitchCase="'required'">Required</span>
        <span *ngSwitchCase="'mindate'">Date cannot be less than {{ minDateReadableDisplay }}</span>
        <span *ngSwitchCase="'maxdate'">Date cannot be greater than {{ maxDateReadableDisplay }}</span>
        <span *ngSwitchCase="'dateforbidden'">Date collides with existing payor</span>
      </ng-container>
    </mat-error>
</div>